import { forwardRef } from '@heroui/system';
import { Card, CardProps, CardHeader, CheckboxProps, Checkbox, CustomAvatarProps } from '@ds';
import { TmdxUser, CustomUserProps } from '@ui';

type CustomCardProps = CardProps & {
  title: CustomUserProps['title'];
  subTitle?: CustomUserProps['description'];
  children?: CustomUserProps['children'];
  hasCheckbox: boolean;
  checkBoxProps?: CheckboxProps;
  avatarProps?: CustomAvatarProps;
};

export const ClinicalResourceCard = forwardRef<'div', CustomCardProps>((props, ref) => {
  const { title, subTitle, children, avatarProps, checkBoxProps, hasCheckbox = false, ...restProps } = props;

  const cardProps: CardProps = restProps;

  return hasCheckbox ? (
    <Checkbox
      classNames={{
        base: 'inline-flex p-2 min-w-48 w-full max-w-full shadow-none rounded-lg bg-base-70',
        wrapper: 'absolute top-2 right-2 mr-0',
        label: 'relative',
      }}
      size="sm"
      {...checkBoxProps}
    >
      <Card ref={ref} className="bg-transparent shadow-none" {...cardProps}>
        <CardHeader className="flex p-0">
          <div className="flex justify-between w-full">
            <TmdxUser
              title={title}
              description={subTitle}
              titleSize="sm"
              descriptionSize="md"
              titleColor="black"
              itemsAlignment="start"
              textGap="none"
              avatarProps={{
                size: 'md',
                radius: 'full',
                ...avatarProps,
              }}
            >
              {children}
            </TmdxUser>
          </div>
        </CardHeader>
      </Card>
    </Checkbox>
  ) : (
    <Card
      ref={ref}
      className="inline-flex p-2 min-w-48 w-full max-w-full shadow-none rounded-lg bg-base-70"
      {...cardProps}
    >
      <CardHeader className="flex p-0">
        <div className="flex justify-between w-full">
          <TmdxUser
            title={title}
            description={subTitle}
            titleSize="sm"
            descriptionSize="md"
            titleColor="black"
            itemsAlignment="start"
            textGap="none"
            avatarProps={{
              size: 'md',
              radius: 'full',
              ...avatarProps,
            }}
          >
            {children}
          </TmdxUser>
        </div>
      </CardHeader>
    </Card>
  );
});
